import type { TIconProps } from "./types";

// NOTE: Moonshot AI Kimi brand mark. Ported from the landing site provider icons.
export const KimiK = (props: TIconProps) => {
  return (
    <svg
      width={16}
      height={16}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.1487 0.000610352C18.6398 0.000610352 19.1108 0.195709 19.4581 0.542986C19.8054 0.890264 20.0004 1.36127 20.0004 1.8524C20.0004 2.34352 19.8054 2.81453 19.4581 3.16181C19.1108 3.50909 18.6398 3.70418 18.1487 3.70418H16.5155C16.4868 3.70431 16.4584 3.69878 16.4319 3.6879C16.4054 3.67702 16.3813 3.661 16.361 3.64078C16.3406 3.62056 16.3245 3.59653 16.3135 3.57006C16.3025 3.54359 16.2969 3.51521 16.2969 3.48655V1.8524C16.2969 0.829726 17.126 0.000610352 18.1487 0.000610352Z"
        fill="#198CE9"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.76633 10.7864L14.7546 3.85307C14.8865 3.72211 14.8124 3.45825 14.6429 3.45825H10.8815C10.8604 3.45849 10.8396 3.46296 10.8202 3.4714C10.8009 3.47983 10.7834 3.49206 10.7689 3.50736L3.23846 10.9761C3.12098 11.0917 2.94764 10.9887 2.94764 10.8038V3.6807C2.94764 3.5584 2.86772 3.45921 2.7695 3.45921H0.179112C0.0799264 3.45921 0 3.5584 0 3.6807V19.04C0 19.1633 0.0799264 19.2615 0.179112 19.2615H2.7695C2.86868 19.2615 2.94861 19.1633 2.94861 19.04V15.9104C2.94861 15.8439 2.97268 15.7804 3.01505 15.739L5.34929 13.4221C5.37408 13.3953 5.40765 13.3784 5.44388 13.3743C5.48011 13.3703 5.51659 13.3794 5.54669 13.3999L11.7906 17.9952C12.7823 18.6708 13.9235 19.0948 15.1157 19.2307C15.2197 19.2423 15.3083 19.1392 15.3083 19.0092V16.0625C15.3083 15.9499 15.2409 15.8584 15.1504 15.8439C14.4507 15.7309 13.7844 15.4656 13.1984 15.0668L7.7933 11.1533C7.68063 11.0782 7.66619 10.8847 7.76633 10.7864Z"
        fill="#198CE9"
      />
    </svg>
  );
};
